import React from "react"
import SongMenuModal from "./SongMenuModal"
import { HelpModal } from "./HelpModal";


export const ContextModals: React.FC = () =>
    <><SongMenuModal /> <HelpModal/></>


export default ContextModals;